import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';

import LearningModuleSerieList from '../components/LearningModuleSerieList';
import { loadModuleSeries } from '../../../../../state/modules/learnings/actions';

const defaultLimit = 20;
const defaultOrder = 'order.asc';

const mapStateToProps = (state, ownProps) => {
  const action = ownProps.action;
  const activeId = state.careGuides.get('activeId');
  const careGuide = activeId
    ? denormalize(
        state.entities.getIn(['careGuides', activeId]),
        schema.careGuide,
        state.entities.toJS()
      )
    : null;

  const partnershipId = careGuide ? careGuide?.partnership.id : null;

  // merge results for all module series
  const results = [].concat.apply(
    [],
    Object.entries(
      state.learnings.getIn(
        [
          'moduleSeries',
          activeId,
          partnershipId,
          action,
          'pages',
          defaultOrder,
          defaultLimit,
        ],
        {}
      )
    ).map(([k, v]) => v.toArray())
  );

  const list =
    results.length > 0
      ? results.map((x) => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['learningModuleSeries', x]),
              schema.learningModuleSerie,
              state.entities.toJS()
            ),
          };
        })
      : [];

  return {
    list,
    activeId,
    partnershipId,
    action,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (
      careGuideId,
      partnershipId,
      action,
      filter = {},
      page = 1,
      limit = defaultLimit,
      order = defaultOrder,
      cb = function () {}
    ) => {
      dispatch(
        loadModuleSeries(
          careGuideId,
          partnershipId,
          action,
          filter,
          page,
          limit,
          order,
          (success, total) => {
            if (success) {
              // loop over all pages to get all module series
              const pageCount = Math.ceil(total / limit);

              for (let i = 2; i <= pageCount; i++) {
                dispatch(
                  loadModuleSeries(
                    careGuideId,
                    partnershipId,
                    action,
                    filter,
                    i,
                    limit,
                    order
                  )
                );
              }
              cb();
            }
          }
        )
      );
    },
  };
};

const LearningModuleSerieListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningModuleSerieList);

export default LearningModuleSerieListContainer;
